<template>
    <div class="text-center">
        <button
            class="w-10 h-10 border border-gray-300 rounded-full hover:border-gray-400 hover:bg-gray-100 m-2 focus:outline-none"
            :disabled="isPreviousButtonDisabled"
            :class="{ 'opacity-50 cursor-not-allowed' : isPreviousButtonDisabled  }"
            @click.prevent="previousPage"
        >
            <font-awesome-icon
                icon="arrow-left"
                class="text-purple-500"
            />
        </button>

        <BasePaginationTrigger
            v-for="(paginationTrigger, index) in paginationTriggers"
            :class="{ 'current': paginationTrigger === currentPage }"
            :key="index"
            :pageNumber="paginationTrigger"
            @loadPage="onLoadPage"
        />

        <button
            class="w-10 h-10 border border-gray-300 rounded-full text-purple-500 hover:border-gray-400 hover:bg-gray-100 m-2 focus:outline-none"
            :class="{ 'opacity-50 cursor-not-allowed' : isNextButtonDisabled  }"
            :disabled="isNextButtonDisabled"
            @click.prevent="nextPage"
        >
            <font-awesome-icon
                icon="arrow-right"
            />
        </button>
    </div>
</template>

<script>
    import BasePaginationTrigger from './BasePaginationTrigger.vue'

    export default {
        props: {
            currentPage: {
                type: Number,
                required: true
            },
            pageCount: {
                type: Number,
                required: true
            },
            visiblePagesCount: {
                type: Number,
                default: 5
            }
        },
        computed: {
            isPreviousButtonDisabled() {
                return this.currentPage === 1
            },
            isNextButtonDisabled() {
                return this.currentPage === this.pageCount
            },
            paginationTriggers() {
                const currentPage = this.currentPage // 1
                const pageCount = this.pageCount // 2
                const visiblePagesCount = this.visiblePagesCount // 5
                const visiblePagesThreshold = (visiblePagesCount - 1) / 2 // 2
                const pagintationTriggersArray = Array(this.visiblePagesCount - 1).fill(0) // 4

                // pageCount is less than visible{agesCount
                if(pageCount <= visiblePagesCount) {
                    let pagintationTriggersArray = Array(this.pageCount).fill(0)
                    const pagintationTriggers = pagintationTriggersArray.map(
                        (paginationTrigger, index) => {
                            return paginationTrigger + index + 1
                        }
                    )
                    return pagintationTriggers
                }

                // 1st scenario
                if (currentPage <= visiblePagesThreshold + 1) {
                    pagintationTriggersArray[0] = 1
                    const pagintationTriggers = pagintationTriggersArray.map(
                        (paginationTrigger, index) => {
                            return pagintationTriggersArray[0] + index
                        }
                    )
                    pagintationTriggers.push(pageCount)
                    return pagintationTriggers
                }

                // 2nd scenario
                if (currentPage >= pageCount - visiblePagesThreshold + 1) {
                    const pagintationTriggers = pagintationTriggersArray.map(
                        (paginationTrigger, index) => {
                            return pageCount - index
                        }
                    )
                    pagintationTriggers.reverse().unshift(1)
                    return pagintationTriggers
                }

                // all other scenarios
                pagintationTriggersArray[0] = currentPage - visiblePagesThreshold + 1
                const pagintationTriggers = pagintationTriggersArray.map(
                    (paginationTrigger, index) => {
                        return pagintationTriggersArray[0] + index
                    }
                )
                pagintationTriggers.unshift(1);
                pagintationTriggers[pagintationTriggers.length - 1] = pageCount
                return pagintationTriggers
            }
        },
        methods: {
            nextPage() {
                this.$emit('nextPage')
            },
            previousPage() {
                this.$emit('previousPage')
            },
            onLoadPage(value) {
                this.$emit("loadPage", value)
            }
        },
        components: {
            BasePaginationTrigger
        }
    }
</script>